/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DressingsCreateAliases {
  ACTION_CANCEL_DRESSING = 'action-cancel-dressing',
  ACTION_RELEASE_DRESSING = 'action-release-dressing',
  AUTOCOMPLETE_DRESSING_AMOUNT_NECROTIC_TISSUE = 'autocomplete-dressing-amount-necrotic-tissue',
  AUTOCOMPLETE_DRESSING_DEAD_SPACE = 'autocomplete-dressing-dead-space',
  AUTOCOMPLETE_DRESSING_DEGREE_OR_STAGE = 'autocomplete-dressing-degree-or-stage',
  AUTOCOMPLETE_DRESSING_DEPTH = 'autocomplete-dressing-depth',
  AUTOCOMPLETE_DRESSING_EPITHELIALIZATION = 'autocomplete-dressing-epithelialization',
  AUTOCOMPLETE_DRESSING_EXUDATE_AMOUNT = 'autocomplete-dressing-exudate-amount',
  AUTOCOMPLETE_DRESSING_GANGRENE = 'autocomplete-dressing-gangrene',
  AUTOCOMPLETE_DRESSING_GRANULATION_TISSUE = 'autocomplete-dressing-granulation-tissue',
  AUTOCOMPLETE_DRESSING_HARDENING_OF_PERIPHERAL_TISSUE = 'autocomplete-dressing-hardening-of-peripheral-tissue',
  AUTOCOMPLETE_DRESSING_MACERATION = 'autocomplete-dressing-maceration ',
  AUTOCOMPLETE_DRESSING_PAIN_AROUND = 'autocomplete-dressing-pain-around',
  AUTOCOMPLETE_DRESSING_PERIPHERAL_TISSUE_EDEMA = 'autocomplete-dressing-peripheral-tissue-edema',
  AUTOCOMPLETE_DRESSING_PRIORITY = 'autocomplete-dressing-priority',
  AUTOCOMPLETE_DRESSING_SECTOR = 'autocomplete-dressing-sector',
  AUTOCOMPLETE_DRESSING_SIZE = 'autocomplete-dressing-size',
  AUTOCOMPLETE_DRESSING_SKIN_COLOR_AROUND_WOUND = 'autocomplete-dressing-skin-color-around-wound',
  AUTOCOMPLETE_DRESSING_TYPE_NECROTIC_TISSUE = 'autocomplete-dressing-type-necrotic-tissue',
  AUTOCOMPLETE_DRESSING_TYPE_OF_EXUDATE = 'autocomplete-dressing-type-of-exudate',
  CONTEXTUAL_BAR_BODY = 'contextual-bar-body',
  DATE_FIELD_DRESSING_RECORD_DATE = 'date-field-dressing-record-date',
  FETCH_DRESSING_AMOUNT_NECROTIC_TISSUE = 'fetch-dressing-amount-necrotic-tissue',
  FETCH_DRESSING_DEAD_SPACE = 'fetch-dressing-dead-space',
  FETCH_DRESSING_DEGREE_OR_STAGE = 'fetch-dressing-degree-or-stage',
  FETCH_DRESSING_DEPTH = 'fetch-dressing-depth',
  FETCH_DRESSING_EPITHELIALIZATION = 'fetch-dressing-epithelialization',
  FETCH_DRESSING_EXUDATE_AMOUNT = 'fetch-dressing-exudate-amount',
  FETCH_DRESSING_GANGRENE = 'fetch-dressing-gangrene',
  FETCH_DRESSING_GRANULATION_TISSUE = 'fetch-dressing-granulation-tissue',
  FETCH_DRESSING_HARDENING_OF_PERIPHERAL_TISSUE = 'fetch-dressing-hardening-of-peripheral-tissue',
  FETCH_DRESSING_MACERATION = 'fetch-dressing-maceration ',
  FETCH_DRESSING_PAIN_AROUND = 'fetch-dressing-pain-around',
  FETCH_DRESSING_PERIPHERAL_TISSUE_EDEMA = 'fetch-dressing-peripheral-tissue-edema',
  FETCH_DRESSING_PRIORITY = 'fetch-dressing-priority',
  FETCH_DRESSING_SECTOR = 'fetch-dressing-sector',
  FETCH_DRESSING_SIZE = 'fetch-dressing-size',
  FETCH_DRESSING_SKIN_COLOR_AROUND_WOUND = 'fetch-dressing-skin-color-around-wound',
  FETCH_DRESSING_TYPE_NECROTIC_TISSUE = 'fetch-dressing-type-necrotic-tissue',
  FETCH_DRESSING_TYPE_OF_EXUDATE = 'fetch-dressing-type-of-exudate',
  FIELD_DRESSING_AMOUNT_NECROTIC_TISSUE = 'field-dressing-amount-necrotic-tissue',
  FIELD_DRESSING_DEAD_SPACE = 'field-dressing-dead-space',
  FIELD_DRESSING_DEGREE_OR_STAGE = 'field-dressing-degree-or-stage',
  FIELD_DRESSING_DEPTH = 'field-dressing-depth',
  FIELD_DRESSING_DEPTH_CM = 'field-dressing-depth-cm',
  FIELD_DRESSING_DRESCRIPTION_RESULT = 'field-dressing-drescription-result',
  FIELD_DRESSING_EPITHELIALIZATION = 'field-dressing-epithelialization',
  FIELD_DRESSING_EXUDATE_AMOUNT = 'field-dressing-exudate-amount',
  FIELD_DRESSING_GANGRENE = 'field-dressing-gangrene',
  FIELD_DRESSING_GRANULATION_TISSUE = 'field-dressing-granulation-tissue',
  FIELD_DRESSING_HARDENING_OF_PERIPHERAL_TISSUE = 'field-dressing-hardening-of-peripheral-tissue',
  FIELD_DRESSING_LENGTH_CM = 'field-dressing-length-cm',
  FIELD_DRESSING_MACERATION = 'field-dressing-maceration ',
  FIELD_DRESSING_NOTE = 'field-dressing-note',
  FIELD_DRESSING_PAIN_AROUND = 'field-dressing-pain-around',
  FIELD_DRESSING_PERIPHERAL_TISSUE_EDEMA = 'field-dressing-peripheral-tissue-edema',
  FIELD_DRESSING_PRIORITY = 'field-dressing-priority',
  FIELD_DRESSING_RECORD_DATE = 'field-dressing-record-date',
  FIELD_DRESSING_RECORD_TIME = 'field-dressing-record-time',
  FIELD_DRESSING_RESULT_SCORE = 'field-dressing-result-score',
  FIELD_DRESSING_SECTOR = 'field-dressing-sector',
  FIELD_DRESSING_SIZE = 'field-dressing-size',
  FIELD_DRESSING_SKIN_COLOR_AROUND_WOUND = 'field-dressing-skin-color-around-wound',
  FIELD_DRESSING_TIME_MIN = 'field-dressing-time-min',
  FIELD_DRESSING_TOTAL_SCORE = 'field-dressing-total-score',
  FIELD_DRESSING_TYPE_NECROTIC_TISSUE = 'field-dressing-type-necrotic-tissue',
  FIELD_DRESSING_TYPE_OF_EXUDATE = 'field-dressing-type-of-exudate',
  FIELD_DRESSING_VALIDITY_HOURS = 'field-dressing-validity-hours',
  FIELD_DRESSING_WIDTH_CM = 'field-dressing-width-cm',
  FORM_FIVE = 'form-five',
  FORM_FOUR = 'form-four',
  FORM_ONE = 'form-one',
  FORM_SIX = 'form-six',
  FORM_THREE = 'form-three',
  FORM_TWO = 'form-two',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_DRESSING_DEPTH_CM = 'input-dressing-depth-cm',
  INPUT_DRESSING_LENGTH_CM = 'input-dressing-length-cm',
  INPUT_DRESSING_RESULT_SCORE = 'input-dressing-result-score',
  INPUT_DRESSING_TIME_MIN = 'input-dressing-time-min',
  INPUT_DRESSING_TOTAL_SCORE = 'input-dressing-total-score',
  INPUT_DRESSING_VALIDITY_HOURS = 'input-dressing-validity-hours',
  INPUT_DRESSING_WIDTH_CM = 'input-dressing-width-cm',
  LAYOUT_DRESSINGS_CREATE = 'layout-dressings-create',
  MAPPER_DRESSING_AMOUNT_NECROTIC_TISSUE = 'mapper-dressing-amount-necrotic-tissue',
  MAPPER_DRESSING_DEAD_SPACE = 'mapper-dressing-dead-space',
  MAPPER_DRESSING_DEGREE_OR_STAGE = 'mapper-dressing-degree-or-stage',
  MAPPER_DRESSING_DEPTH = 'mapper-dressing-depth',
  MAPPER_DRESSING_EPITHELIALIZATION = 'mapper-dressing-epithelialization',
  MAPPER_DRESSING_EXUDATE_AMOUNT = 'mapper-dressing-exudate-amount',
  MAPPER_DRESSING_GANGRENE = 'mapper-dressing-gangrene',
  MAPPER_DRESSING_GRANULATION_TISSUE = 'mapper-dressing-granulation-tissue',
  MAPPER_DRESSING_HARDENING_OF_PERIPHERAL_TISSUE = 'mapper-dressing-hardening-of-peripheral-tissue',
  MAPPER_DRESSING_MACERATION = 'mapper-dressing-maceration ',
  MAPPER_DRESSING_PAIN_AROUND = 'mapper-dressing-pain-around',
  MAPPER_DRESSING_PERIPHERAL_TISSUE_EDEMA = 'mapper-dressing-peripheral-tissue-edema',
  MAPPER_DRESSING_PRIORITY = 'mapper-dressing-priority',
  MAPPER_DRESSING_SECTOR = 'mapper-dressing-sector',
  MAPPER_DRESSING_SIZE = 'mapper-dressing-size',
  MAPPER_DRESSING_SKIN_COLOR_AROUND_WOUND = 'mapper-dressing-skin-color-around-wound',
  MAPPER_DRESSING_TYPE_NECROTIC_TISSUE = 'mapper-dressing-type-necrotic-tissue',
  MAPPER_DRESSING_TYPE_OF_EXUDATE = 'mapper-dressing-type-of-exudate',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  TEXT_AREA_DRESSING_DRESCRIPTION_RESULT = 'text-area-dressing-drescription-result',
  TEXT_AREA_DRESSING_NOTE = 'text-area-dressing-note',
  TEXT_DRESSING_AMOUNT_NECROTIC_TISSUE = 'text-dressing-amount-necrotic-tissue',
  TEXT_DRESSING_DEAD_SPACE = 'text-dressing-dead-space',
  TEXT_DRESSING_DEGREE_OR_STAGE = 'text-dressing-degree-or-stage',
  TEXT_DRESSING_DEPTH = 'text-dressing-depth',
  TEXT_DRESSING_EPITHELIALIZATION = 'text-dressing-epithelialization',
  TEXT_DRESSING_EXUDATE_AMOUNT = 'text-dressing-exudate-amount',
  TEXT_DRESSING_GANGRENE = 'text-dressing-gangrene',
  TEXT_DRESSING_GRANULATION_TISSUE = 'text-dressing-granulation-tissue',
  TEXT_DRESSING_HARDENING_OF_PERIPHERAL_TISSUE = 'text-dressing-hardening-of-peripheral-tissue',
  TEXT_DRESSING_MACERATION = 'text-dressing-maceration ',
  TEXT_DRESSING_PAIN_AROUND = 'text-dressing-pain-around',
  TEXT_DRESSING_PERIPHERAL_TISSUE_EDEMA = 'text-dressing-peripheral-tissue-edema',
  TEXT_DRESSING_PRIORITY = 'text-dressing-priority',
  TEXT_DRESSING_SECTOR = 'text-dressing-sector',
  TEXT_DRESSING_SIZE = 'text-dressing-size',
  TEXT_DRESSING_SKIN_COLOR_AROUND_WOUND = 'text-dressing-skin-color-around-wound',
  TEXT_DRESSING_TYPE_NECROTIC_TISSUE = 'text-dressing-type-necrotic-tissue',
  TEXT_DRESSING_TYPE_OF_EXUDATE = 'text-dressing-type-of-exudate',
  TIME_FIELD_DRESSING_RECORD_TIME = 'time-field-dressing-record-time',
  WIZARD = 'wizard',
  WIZARD_STEP_0 = 'wizard-step-0',
  WIZARD_STEP_1 = 'wizard-step-1',
  WIZARD_STEP_2 = 'wizard-step-2',
  WIZARD_STEP_FIVE = 'wizard-step-five',
  WIZARD_STEP_FOUR = 'wizard-step-four',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_SIX = 'wizard-step-six',
  WIZARD_STEP_THREE = 'wizard-step-three',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { DressingsCreateAliases };
